module.exports = __webpack_public_path__ + "media/icons/twitter-light-16aa221f.png";